module.exports = __webpack_public_path__ + "static/4-2b405fbd9b8d0a3fd60968509299f7f4.png";